import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { doc, deleteDoc } from 'firebase/firestore';
import { db } from '../../config/firebase';
import { useAuth } from '../../hooks/useAuth';
import Button from '../common/Button';

const ProjectCard = ({ project, compact = false, onDelete }) => {
  const { userProfile } = useAuth();
  const [deleting, setDeleting] = useState(false);

  const handleDelete = async () => {
    if (!window.confirm(`Are you sure you want to delete "${project.name}"? This action cannot be undone.`)) {
      return;
    }

    try {
      setDeleting(true);
      await deleteDoc(doc(db, 'projects', project.id));
      onDelete?.(project.id);
    } catch (error) {
      console.error('Error deleting project:', error);
      alert('Failed to delete project');
    } finally {
      setDeleting(false);
    }
  };

  const canDelete = project.createdBy === userProfile?.uid || userProfile?.role === 'admin';

  if (compact) {
    return (
      <Link
        to={`/projects/${project.id}`}
        className="block p-4 bg-white dark:bg-gray-800 rounded-lg border border-gray-200 dark:border-gray-700 hover:shadow-md transition-shadow"
      >
        <div className="flex items-center justify-between">
          <div>
            <h3 className="font-medium text-gray-900 dark:text-white">
              {project.name}
            </h3>
            <p className="text-sm text-gray-500 dark:text-gray-400 mt-1">
              {project.description}
            </p>
          </div>
          <div className="text-2xl">{project.emoji}</div>
        </div>
      </Link>
    );
  }

  return (
    <div className="bg-white dark:bg-gray-800 rounded-lg shadow-sm border border-gray-200 dark:border-gray-700 overflow-hidden">
      <Link to={`/projects/${project.id}`}>
        <div className="p-6">
          <div className="flex items-start justify-between mb-4">
            <div>
              <h3 className="text-lg font-semibold text-gray-900 dark:text-white">
                {project.name}
              </h3>
              <p className="text-gray-500 dark:text-gray-400 mt-1">
                {project.description}
              </p>
            </div>
            <div className="text-3xl">{project.emoji}</div>
          </div>
          
          <div className="flex items-center justify-between text-sm text-gray-500 dark:text-gray-400">
            <span>Key: {project.key}</span>
            <span>
              {project.members?.length || 0} member{project.members?.length !== 1 ? 's' : ''}
            </span>
          </div>
        </div>
      </Link>
      
      {canDelete && (
        <div className="px-6 py-3 bg-gray-50 dark:bg-gray-700 border-t border-gray-200 dark:border-gray-600">
          <Button
            variant="danger"
            size="small"
            loading={deleting}
            onClick={handleDelete}
          >
            Delete Project
          </Button>
        </div>
      )}
    </div>
  );
};

export default ProjectCard;